import {
  GridColDef,
  GridRenderCellParams,
  GridRowModesModel,
} from "@mui/x-data-grid";
import GridViewMUIX from "../../../../components/GridViewMUIX";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";

import { getRoutes } from "src/utilities/routes";

import { useParams } from "react-router-dom";
import { ITransaction } from "src/interface/ITransaction";
import moment from "jalali-moment";
import AccordingTemplate from "./AccordingTemplate";
import { calculateBalance } from "src/utilities";
import { Box, Stack, Typography } from "@mui/material";
import SkeltonProgress from "src/components/SkeltonProgress";
import { IAppUser } from "src/interface/IUser";
const TransactionList = ({
  customerId,
  setAmount,
}: {
  customerId: string;
  setAmount: (amount: number) => void;
}) => {
  const notifications = useNotifications();
  const Routes = getRoutes();
  const [rows, setRows] = useState<ITransaction[]>([]);

  const {
    mutate: getTransactionsByUserId,
    isPending: isTransactionByUserIdLoading,
  } = useMutation({
    mutationFn: async (id: string) => {
      const response = await fetch(Routes.TransactionRoutes + "user/" + id, {
        method: "GET",
        headers: {
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData: ITransaction[]) => {
      if (responseData && responseData.length > 0) {
        setRows(responseData.filter((item) => item.transactionStatus === 1)); // فیلتر کردن ردیف‌ها بر اساس isDebit
      }
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  useEffect(() => {
    if (customerId) {
      getTransactionsByUserId(customerId);
    }
  }, [customerId]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const columnsUser: GridColDef[] = [
    {
      field: "transactionDate",
      headerName: "تاریخ",
      align: "center",
      headerAlign: "center",

      minWidth: 100,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },

    {
      field: "amount",
      headerName: "گردش(ريال)",
      align: "center",
      headerAlign: "center",

      minWidth: 120,

      renderCell: (params: GridRenderCellParams<any, string>) => {
        return (
          params.value?.toLocaleString() + (params.row?.isDebit ? "+" : "-")
        );
      },
    },
    {
      field: "balance",
      headerName: "مانده(ريال)",
      align: "center",
      headerAlign: "center",

      sortable: false, // مرتب‌سازی نداره چون وابسته به ترتیب ردیف‌هاست
      minWidth: 120,
      renderCell: (params: GridRenderCellParams<any, any>) => {
        const rows = params.api.getRowModels(); // گرفتن همه ردیف‌ها
        const currentIndex = params.api.getRowIndexRelativeToVisibleRows(
          params.id
        ); // اندیس ردیف فعلی
        const previousRows = Array.from(rows.values()).slice(
          0,
          currentIndex + 1
        ); // ردیف‌ها تا این ردیف

        const balance = previousRows.reduce((sum, row) => {
          const amount = row.amount || 0;
          return row.isDebit ? sum + amount : sum - amount;
        }, 0);

        return balance.toLocaleString(); // نمایش با جداکننده هزارگان
      },
    },
    {
      field: "description",
      headerName: "شرح",
      align: "left",
      headerAlign: "left",
      flex: 1,
      minWidth: 250,
      renderCell: (params: GridRenderCellParams<any, string>) => {
        return (
          <Typography
            style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
          >
            {params.value}
          </Typography>
        );
      },
    },
  ];

  useEffect(() => {
    if (rows && rows.length > 0) {
      const balance = calculateBalance(rows);
      setAmount(balance);
    }
  }, [rows]);

  return (
    <Box>
      <>
        <AccordingTemplate
          title="نمایش گردش"
          key={"balance"}
          title2={
            "مانده: " +
            (rows && rows.length > 0
              ? calculateBalance(rows).toLocaleString()
              : 0) +
            " ریال"
          }
        >
          {isTransactionByUserIdLoading ? (
            <SkeltonProgress />
          ) : (
            <GridViewMUIX
              columns={columnsUser}
              loading={isTransactionByUserIdLoading}
              rowModesModel={rowModesModel}
              sortFields={{ field: "transactionDate", sort: "asc" }}
              rows={rows}
              setRowModesModel={setRowModesModel}
              gridUniqueName="PayFactor"
              disableColumnFilter
              disableColumnMenu
              disableColumnSelector
              disableDensitySelector
              pageSize={100}
              showQuickFilter={false}
              getRowHeight="auto"
              checkboxSelection={false}
            />
          )}
        </AccordingTemplate>
      </>
    </Box>
  );
};

export default TransactionList;
